// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kv-0";
export var discountCodeInput = "_kv-1";